import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'components/modal';
import InPlaceText from 'components/form/in_place_text';
import { isPresent, isBlank } from '@seedlang/utils/src';
import { AppUI } from '@seedlang/state';
import InfoTooltip from 'components/info_tooltip';
import Grid from 'components/layout/grid';

@observer
class WordTagEdit extends React.Component {

  render() {
    if (isPresent(this.props.concept)) {
      return (
        <Modal
          title={this.props.concept?.name}
          gradient={isBlank(AppUI.site.accentColor)}
          background={AppUI.site.accentColor}
          onCloseModal={this.props.onClose}
        >
          <Grid columns={[2,1]} gap='sm'>
            <InPlaceText
              legend='Name'
              defaultValue={this.props.concept?.name}
              model='concepts'
              field='name'
              id={this.props.concept?.id}
              afterChange={this.props.onChange}
            />
            <InPlaceText
            legend='Abbreviation'
            defaultValue={this.props.concept?.abbreviation}
            model='concepts'
            field='abbreviation'
            id={this.props.concept?.id}
            afterChange={this.props.onChange}
            />
          </Grid>
          <InPlaceText
            legend={<>Description <InfoTooltip>If a description exists, users can click on the tag and read it.</InfoTooltip></>}
            richText
            show
            wrapperClassName='word-info'
            defaultValue={this.props.concept.longDescription}
            model='concepts'
            field='long_description'
            inputType='textarea'
            id={this.props.concept.id}
            afterChange={this.props.onChange}
          />
        </Modal>
      );
    }
  }
}

export default WordTagEdit;
